<template>
  <div id="loading-bg">
    <div class="loading-logo">
      <img src="/logo.png" alt="Logo" />
    </div>
    <div class="loading">
      <div class="effect-1 effects"></div>
      <div class="effect-2 effects"></div>

      <div class="effect-3 effects"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Loader",
};
</script>
